var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item_row heading"},[_c('div',{staticClass:"ava"},[_c('div',{staticClass:"view_list"}),_c('div',{staticClass:"view_map"})]),_c('div',{staticClass:"name"},[_c('span',[_vm._v("Name")])]),_c('div',{staticClass:"location"},[_vm._v("Location")]),_c('div',{staticClass:"followers"},[_c('span',[_vm._v("Followers")])]),_c('div',{staticClass:"more"})])
}]

export { render, staticRenderFns }